import React from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { setAlertActionCreator, setLoadingActionCreator } from 'plugins/store/reducers/common.reducer';

import SnackMessage from 'components/Snackbar/SnackMessage';
import ResponseDialogTempate from './ResponseDialogTempate'
import { uploadCsv } from 'services/rep-list.service';
import CsvUpload from 'components/CustomUpload/CsvUpload';

class UploadRepList extends React.Component {
	openResponseDialog = (props) => {
		this.props.setAlert({
			type: 'scrollable',
			maxWidth: 'xs',
			children: <ResponseDialogTempate {...props} />,
			onConfirm: () =>	this.props.setAlert(null),
		});
	}

	onCsvLoad = async (file) => {
		const { callCenterId, setGlobalLoading } = this.props;
		try {
			setGlobalLoading(true);
			const response = await uploadCsv(callCenterId, file);
			this.openResponseDialog(response);
			if (this.props.onUploaded) {
				this.props.onUploaded();
			}
		} catch (e) {
			this.props.enqueueSnackbar(e.resolvedErrorMessage, {
				content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
			});
		}
		setGlobalLoading(false);
	}

	render() {
		return <CsvUpload onLoad={this.onCsvLoad} />
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setAlert: (dialog) => dispatch(setAlertActionCreator(dialog)),
	setGlobalLoading: (isLoading) => dispatch(setLoadingActionCreator(isLoading))
});

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(UploadRepList));
